import { createCustomElement } from "../model.js";
if (!window.WebComponents) {
  window.WebComponents = {};
}
const registerWebComponent = ({ name, element }) => {
  if (window.customElements.get(name)) {
    return;
  }
  const hasElement = document.getElementsByTagName(name).length > 0;
  if (!hasElement) {
    return;
  }
  window.WebComponents[name] = element;
  window.customElements.define(name, element);
};
function webComponent(config) {
  return () => {
    const normalizedConfig = {
      ...config,
      attributes: config.attributes ? Array.isArray(config.attributes) ? config.attributes : [config.attributes] : void 0
    };
    registerWebComponent({
      name: config.tagName,
      element: createCustomElement(normalizedConfig)
    });
  };
}
export {
  registerWebComponent,
  webComponent
};
//# sourceMappingURL=register.js.map
